import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const NavTabCommissions = ({ loading, toggleTab, activeTab }) => {
  return (
    <Nav
      className="nav-tabs-custom mb-3 ms-0 card-header-tabs border-bottom-0"
      role="tablist"
    >
      <NavItem>
        <NavLink
          className={classnames(
            {
              active: activeTab === "1",
              disabled: loading,
              "fw-semibold": activeTab === "1",
            },
            " p-2 text-primary"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("1", "due");
            }
          }}
          href="#"
        >
          DUE
        </NavLink>
      </NavItem>

      <NavItem className="mx-3">
        <NavLink
          className={classnames(
            {
              active: activeTab === "2",
              disabled: loading,
              "fw-semibold": activeTab === "2",
            },
            " p-2 text-primary"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("2", "paid");
            }
          }}
          href="#"
        >
          PAID
        </NavLink>
      </NavItem>

      <NavItem className="mx-3">
        <NavLink
          className={classnames(
            {
              active: activeTab === "3",
              disabled: loading,
              "fw-semibold": activeTab === "3",
            },
            " p-2 text-muted"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("3", "archived");
            }
          }}
          href="#"
        >
          <i className="ri-archive-line me-1"></i>
          ARCHIVED
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export default NavTabCommissions;
